import React from 'react';

type Props = {
  color: string
};

const IndicatorIcon: React.FC<Props> = ({ color }) => (
  <svg width="60" height="69" viewBox="0 0 60 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_534_7001)">
      <path d="M32.1856 47.5459C31.0749 49.1011 28.7598 49.0895 27.6648 47.5233L17.7491 33.341C10.7995 23.4011 17.9109 9.75187 30.0394 9.75187C42.2365 9.75187 49.3317 23.5381 42.2429 33.4638L32.1856 47.5459Z" fill={color} />
      <path d="M27.1884 47.8563C28.5134 49.7515 31.3147 49.7655 32.6587 47.8838L42.716 33.8016C50.0796 23.4912 42.7093 9.17057 30.0394 9.17057C17.4408 9.17057 10.0537 23.3489 17.2727 33.6741L27.1884 47.8563Z" stroke="white" strokeWidth="1.1626" />
    </g>
    <path opacity="0.7" d="M33.8151 22.5478C34.7221 24.6703 33.7367 27.1262 31.6142 28.0332C29.4917 28.9403 27.0358 27.9549 26.1288 25.8324C25.2218 23.7099 26.2071 21.254 28.3296 20.347C30.4521 19.44 32.908 20.4253 33.8151 22.5478Z" fill={color} stroke="white" strokeWidth="0.905044" />
    <defs>
      <filter id="filter0_d_534_7001" x="0.537301" y="0.599725" width="59.0045" height="67.9098" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="5.3261" />
        <feGaussianBlur stdDeviation="6.65762" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_534_7001" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_534_7001" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default IndicatorIcon;
